<template>
    <div class="page-content header-clear-medium">
			<div class="card card-style" style="margin: 0px 15px 30px 15px;">
				<div class="content">
					<div class="row">
						<div class="col-lg-12">
							<ReportFilter 
								:type-filter.sync="tatibTypeFilter" 
								:daily-time.sync="tatibDailyTime" 
								:monthly-time.sync="tatibMonthlyTime" 
								:range-date-from.sync="tatibRangeDateFrom" 
								:range-date-to.sync="tatibRangeDateTo" 
								@set-type-filter="setDataFilter()"
							/>
						</div>
					</div>

					<div class="row mt-3">
						<div class="col-lg-12">
							<button class="btn bg-green-light w-100" @click="getDataTatib()">Cari</button>
						</div>
					</div>
				</div>
			</div>

			<div class="card card-style">
				<div class="content my-3">
					<div class="alert bg-fade-red color-red-dark rounded-s fade show" role="alert">
						<i class="bi bi-exclamation-triangle pe-2"></i>
						<strong>Rekap Catatan Tatib</strong>
					</div>

					<div v-if="!loading">
						<div class="mb-3">
							<div v-if="chartData.labels.length < 1">
								<div class="alert alert-warning">
									Data tidak ditemukan!
								</div>
							</div>
							<!-- <Pie
								v-else
								:chart-options="chartOptions"
								:chart-data="chartData"
								chart-id="pie-chart"
								dataset-id-key="label"
								:plugins="[]"
								css-classes=""
								:styles="{}"
								:width="400"
								:height="400"
							/> -->
							<highcharts :options="tatibChartOptions"></highcharts>
						</div>
						<div class="accordion" id="accordionExample" v-if="tatibDatas.length > 0">
							<div class="accordion-item" v-for="(itemTatib, index) in tatibDatas" :key="itemTatib.name">
								<h2 class="accordion-header bg-red-dark" :id="`heading-${index}`">
									<button class="accordion-button ms-1 text-white" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse-${index}`" aria-expanded="false" :aria-controls="`collapse-${index}`">
											{{ itemTatib.name }}
											&nbsp;
											<small>({{ itemTatib.data.length }} Data Pelanggaran)</small>
											<i class="bi bi-chevron-down text-white"></i>
									</button>
								</h2>
								<div :id="`collapse-${index}`" class="accordion-collapse collapse" :aria-labelledby="`heading-${index}`" data-bs-parent="#accordionExample">
									<div class="accordion-body">
										<ol class="ps-3">
											<div v-for="item in itemTatib.data" :key="item.id">
												<li v-if="item.student != null">
													<span class="font-700 mb-0">{{ item.student ? item.student.nama : '' }}</span> <mark class="highlight ps-2 font-12 pe-2 bg-blue-dark">{{ item.student ? item.student.classroom.nama : '' }}</mark>
												</li>
											</div>
										</ol>
									</div>
								</div>
							</div>
						</div>	
						<div v-else>
							<div class="alert alert-warning">
								Data tidak ditemukan!
							</div>
						</div>
					</div>
					<div v-else>
						<vue-skeleton-loader
							:height="100"
							animation="fade" 
							class="w-100 rounded-s mt-3"
						/>
					</div>
				</div>
			</div>
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, 
	mapState 
} from 'vuex'
// import { Pie } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)
import moment from 'moment'
import ReportFilter from '../components/form/ReportFilter.vue'

export default {
    name: 'Decency',
    components: {
			ReportFilter,
			// Pie,
    },
    data() {
        return {
					presenceDate: moment().format('YYYY-MM-DD'),
					tatibTypeFilter: this.$route.query.type ?? 'all',
					tatibMonthlyTime: this.$route.query.monthly ?? moment().format('MM'),
					tatibDailyTime: this.$route.query.daily ?? moment().format('YYYY-MM-DD'),
					tatibRangeDateFrom: this.$route.query.date_from ?? moment().format('YYYY-MM-DD'),
					tatibRangeDateTo: this.$route.query.date_to ?? moment().format('YYYY-MM-DD'),
					chartOptions: {
						responsive: true,
						maintainAspectRatio: false
					},
        }
    },
    async created() {
			await this.getDataTatib();
    },
    methods: {
			...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
			...mapActions('tatib', ['getTatibs']),
			setDataFilter(value) {
				this.tatibTypeFilter = value;
			},
			async getDataTatib() {
				this.SET_LOADING();
				switch (this.tatibTypeFilter) {
					case 'monthly':
						await this.getDataTatibMonthly()
						break;
					case 'daily':
						await this.getDataTatibDaily()
						break;
					case 'all':
						await this.getDataTatibAll()
						break;
					case 'range':
						await this.getDataTatibRange()
						break;
					default:
						break;
				}
				this.CLEAR_LOADING();
			},
			async getDataTatibDaily() {
				await this.getTatibs({type: this.tatibTypeFilter, time: this.tatibDailyTime})
			},
			async getDataTatibMonthly() {
				await this.getTatibs({type: this.tatibTypeFilter, time: this.tatibMonthlyTime})
			},
			async getDataTatibRange() {
				await this.getTatibs({type: this.tatibTypeFilter, date_from: this.tatibRangeDateFrom, date_to: this.tatibRangeDateTo})
			},
			async getDataTatibAll() {
				await this.getTatibs({type: this.tatibTypeFilter})
			}
    },
    computed: {
			...mapState({
					loading: state => state.loading
			}),
			tatibDatas() {
				const tatibs = this.tatibs;
				const result = [];

				tatibs.forEach(item => {
					let data = [];
					item.clauses.forEach(clause => {
						if(clause.data.length > 0) {
							data.push(clause.data[0]);
						}
					});

					if(data.length > 0) {
						result.push({
							name: item.name,
							data: data
						});
					}
				});

				return result;
			},
			tatibChartOptions() {
				let options = {
					chart: {
						plotBackgroundColor: null,
						plotBorderWidth: null,
						plotShadow: false,
						type: 'pie'
					},
					title: {
						text: 'Laporan Data Tatib'
					},
					series: [{
						name: 'Data Tatib',
						colorByPoint: true,
						data: this.tatibDatas.map(item => {
										return {
											name: item.name,
											y: item.data.length
										};
									})
					}]
				};

				return options;
			},
			chartData() {
				let tempChartData = {
					labels: [],
					datasets: [
						{
							backgroundColor: [],
							data: []
						}
					]
				}

				const labels = this.tatibDatas.map(item => item.name);
				const data = this.tatibDatas.map(item => item.data.length);

				tempChartData.labels = labels;
				data.forEach(element => {
					tempChartData.datasets[0].backgroundColor.push(`#${(Math.random()*0xFFFFFF<<0).toString(16)}`)
					tempChartData.datasets[0].data.push(element)
				})

				return tempChartData;
			},
			...mapState('tatib', {
					tatibs: state => state.tatibs,
			}),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
